module.exports = "/static-assets/_next/static/images/Poloaroid-7-a83d546ddfa3e804d852729d4f3bebe4.png";